// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.update-payment-type-button{background:#f08e13;border:1px solid #f08e13;box-sizing:border-box;border-radius:5px;height:2rem;width:12rem;color:#fff;margin-right:2rem}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
